"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "dateTime", {
  enumerable: true,
  get: function get() {
    return _dateTime.default;
  }
});
Object.defineProperty(exports, "MMDDYYYY", {
  enumerable: true,
  get: function get() {
    return _mmddyyyy.default;
  }
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _dateTime = _interopRequireDefault(require("./dateTime"));

var _mmddyyyy = _interopRequireDefault(require("./mmddyyyy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(input) {
  if (input instanceof _moment.default && input.isValid()) {
    return true;
  }

  if (input instanceof Date && !Number.isNaN(input.valueOf())) {
    return true;
  }

  var d = (0, _moment.default)(input, ['YYYY-MM-DD', 'MM/DD/YYYY']);

  if (!(d instanceof _moment.default) || !d.isValid()) {
    return false;
  }

  var acceptableFormats = ['YYYY-M-D', 'YYYY-MM-DD', 'YY-M-D', 'YY-MM-DD', 'M/D/YYYY', 'MM/DD/YYYY', 'M/D/YY', 'MM/DD/YY'];
  return acceptableFormats.some(function (acceptableFormat) {
    return input.indexOf(d.format(acceptableFormat)) >= 0;
  });
};

exports.default = _default;